var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.instanceSettings)?_c('div',{style:(_vm.globalCSSVars)},[_c('router-view'),_c('global-confirm-modal-dialog')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }